import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { Controls } from '@/features/settings/Controls';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings',
  component: Controls,
});
